<div id="pricing-packages-component" class="pricing-packages p-3">
    <h2>Pricing Packages</h2>
    <div class="table-responsive w-100">
        <table mat-table [dataSource]="pricingPackages()" class="mat-elevation-z8 w-100">
            <ng-container matColumnDef="idx">
                <th mat-header-cell *matHeaderCellDef>
                    <button mat-icon-button (click)="createPackage()">
                        <mat-icon>add</mat-icon>
                    </button>
                </th>
                <td mat-cell *matCellDef="let element"></td>
            </ng-container>
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Package Name</th>
                <td mat-cell *matCellDef="let element">{{ element.name }}</td>
            </ng-container>
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>Type</th>
                <td mat-cell *matCellDef="let element">{{ element.type | pricingPackageType }}</td>
            </ng-container>
            <ng-container matColumnDef="isHidden">
                <th mat-header-cell *matHeaderCellDef>Is Hidden</th>
                <td mat-cell *matCellDef="let element">{{ element.isHidden ? "yes" : "no" }}</td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let element">
                    <div class="d-flex flex-row align-items-center justify-content-between">
                        <button mat-icon-button color="primary" (click)="edit(element.id)" matTooltip="Edit">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button color="warn" (click)="delete(element.id)" matTooltip="Delete">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
    </div>
</div>
